export enum EventType {
  'AMBS_LANDING_PAGE' = 'ambs_landing_page',
  'AMBS_LOGIN_VISIT' = 'ambs_login_visit',
  'AMBS_OTP_PAGE_VISIT' = 'ambs_otp_page_visit',
  'AMBS_SIGNIN_SUCCESS' = 'ambs_signin_success',
  'AMBS_OTP_PAGE_CLICK' = 'ambs_otp_page_click',
  'AMBS_PERSONAL_DETAILS_VISIT' = 'ambs_personal_details_visit',
  'AMBS_PROGRAM_SELECT_VISIT' = 'ambs_program_select_visit',
  'AMBS_PROGRAM_DETAIL_VISIT' = 'ambs_program_detail_visit',
  'AMBS_SIGNUP_SUCCESS' = 'ambs_signup_success',
  'AMBS_DASHBOARD_VISIT' = 'ambs_dashboard_visit',
  'AMBS_PAYMENT_UPDATE_CLICK' = 'ambs_payment_update_click',
  'AMBS_PAYMENT_UPDATE_SUCCESS' = 'ambs_payment_update_success',
  'AMBS_COUPON_CODE_VISIT' = 'ambs_coupon_code_visit',
  'GENERATE_COUPON_CLICK' = 'generate_coupon_click',
  'AMBS_COUPON_CODE_COPY' = 'ambs_coupon_code_copy',
  'AMBS_EARNING_LEVELS_VISIT' = 'ambs_earning_levels_visit',
  'AMBS_PERFORMANCE_REPORT_VISIT' = 'ambs_performance_report_visit',
  'AMBS_RESOURCE_CENTER_VISIT' = 'ambs_resource_center_visit',
  'AMBS_CONTACT_US_CLICK' = 'ambs_contact_us_click',
  'AMBS_PAYMENT_PAGE_VISIT' = 'ambs_payment_page_visit',
  'AMBS_LOGOUT_CLICK' = 'ambs_logout_click',
  'AMBS_COUPON_GENERATION' = 'ambs_coupon_generation',
  'AMBASSADOR_LANDING_PAGE_VIEWED' = 'ambassador_landing_page_viewed',
  'AMBASSADOR_LANDING_CTA_CLICKED' = 'ambassador_landing_cta_clicked',
  'AMBASSADOR_ONBOARDING_CONTINUE_CLICKED' = 'ambassador_onboarding_continue_clicked',
  'AMBASSADOR_ONBOARDING_OTP_VERIFIED' = 'ambassador_onboarding_otp_verified',
  'AMBASSADOR_PROGRAMME_DISCOVERY_PAGE_VIEWED' = 'ambassador_programme_discovery_page_viewed',
  'AMBASSADOR_PROGRAMME_SELECTION_PERSONA_VIEWED' = 'ambassador_programme_selection_persona_viewed',
  'AMBASSADOR_PROGRAMME_SELECTION_PERSONA_SELECTED' = 'ambassador_programme_selection_persona_selected',
  'AMBASSADOR_PROGRAMME_DETAILS_SUBMITTED' = 'ambassador_programme_details_submitted',
  'AMBASSADOR_DASHBOARD_PAGE_VIEWED' = 'ambassador_dashboard_page_viewed',
  'AMBASSADOR_DASHBOARD_ADD_PAYMENT_DETAILS_CLICKED' = 'ambassador_dashboard_add_payment_details_clicked',
  'AMBASSADOR_PAYMENT_DETAILS_VIEWED' = 'ambassador_payment_details_viewed',
  'AMBASSADOR_PAYMENT_SUBMIT_CLICKED' = 'ambassador_payment_submit_clicked',
  'COMMISSION_STRUCTURE_PAGE_VIEWED' = 'commission_structure_page_viewed',
  'MY_ACCOUNT_PAGE_VIEWED' = 'my_account_page_viewed',
  'PERFORMANCE_REPORT_PAGE_VIEWED' = 'performance_report_page_viewed',
  'CONTACT_US_PAGE_VIEWED' = 'contact_us_page_viewed',
  'AMBASSADOR_DASHBOARD_SHARE_OFFER_CLICKED' = 'ambassador_dashboard_share_offer_clicked',
  'AMBASSADOR_SEND_OFFER_PAGE_VIEWED' = 'ambassador_send_offer_page_viewed',
  'AMBASSADOR_SEND_OFFER_ELIGIBILITY_CHECK_CLICKED' = 'ambassador_send_offer_eligibility_check_clicked',
  'AMBASSADOR_SEND_OFFER_REDIRECT_TO_ASSISTED_SALES_CLICKED' = 'ambassador_send_offer_redirect_to_assisted_sales_clicked',
  'AMBASSADOR_SEND_OFFER_OTP_SCREEN_VIEWED' = 'ambassador_send_offer_otp_screen_viewed',
  'AMBASSADOR_SEND_OFFER_VERIFY_OTP_CLICKED' = 'ambassador_send_offer_verify_otp_clicked',
  'AMBASSADOR_SEND_OFFER_SUCCESS_SCREEN_VIEWED' = 'ambassador_send_offer_success_screen_viewed',
  'AMBASSADOR_DASHBOARD_GENERATE_COUPON_CLICKED' = 'ambassador_dashboard_generate_coupon_clicked',
  'AMBASSADOR_COUPON_GENERATED' = 'ambassador_coupon_generated'
}

export interface PwEvent {
  type: EventType
}
